<template>
  <div class="OnboardingModal">
    <div class="OnboardingModal-title-container">
      <h1 class="OnboardingModal-title">
        {{
          $t(
            'dashboard.volunteerDashboard.VolunteerOnboardingModal.titleContainer.title'
          )
        }}
      </h1>
      <p class="OnboardingModal-subtitle">
        {{
          $t(
            'dashboard.volunteerDashboard.VolunteerOnboardingModal.titleContainer.subtitle'
          )
        }}
      </p>
    </div>
    <div class="OnboardingModal-message"></div>
    <div class="OnboardingModal-steps-container">
      <div>
        <img
          src="@/assets/onboarding_icons/calendar-icon.png"
          class="OnboardingModal-icon"
          alt="calendar icon"
        />
        <h4>
          {{
            $t(
              'dashboard.volunteerDashboard.VolunteerOnboardingModal.stepsContainer.header-1'
            )
          }}
        </h4>
        <p>
          {{
            $t(
              'dashboard.volunteerDashboard.VolunteerOnboardingModal.stepsContainer.description-1'
            )
          }}
        </p>
      </div>
      <div>
        <img
          src="@/assets/onboarding_icons/quiz-icon.png"
          class="OnboardingModal-icon"
          alt="quiz icon"
        />
        <h4>
          {{
            $t(
              'dashboard.volunteerDashboard.VolunteerOnboardingModal.stepsContainer.header-2'
            )
          }}
        </h4>
        <p>
          {{
            $t(
              'dashboard.volunteerDashboard.VolunteerOnboardingModal.stepsContainer.description-2'
            )
          }}
        </p>
      </div>
    </div>
    <large-button v-if="mobileMode" primary @click.native="onAccept">
      {{ modalData.acceptText }}
    </large-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LargeButton from '@/components/LargeButton.vue'
import i18n from '@/i18n'

export default {
  components: { LargeButton },
  props: {
    modalData: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      mobileMode: 'app/mobileMode',
    }),
  },
  methods: {
    onAccept() {
      this.$store.dispatch('user/firstDashboardVisit', false)
      this.$router.push(`/${i18n.locale}/calendar`)
    },
  },
}
</script>

<style lang="scss" scoped>
.OnboardingModal {
  @include flex-container(column);
  @include child-spacing(top, 24px);
  @include breakpoint-above('medium') {
    @include child-spacing(top, 16px);
  }
}

.OnboardingModal-title {
  @include font-category('display-small');
  @include breakpoint-above('medium') {
    margin-top: 24px;
  }
}

.OnboardingModal-message {
  @include font-category('body');
}

.OnboardingModal-title-container {
  margin: 0 auto;
  width: 80%;
}

.OnboardingModal-subtitle {
  font-size: 16px;
  color: $c-secondary-grey;
}

.OnboardingModal-icon {
  width: 100px;
  margin-bottom: 0.6em;
}

.OnboardingModal-steps-container {
  display: flex;
  justify-content: space-around;
}
</style>
